import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import api from "../axiosInstance";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import TaskIcon from "@mui/icons-material/Task";
import DescriptionIcon from "@mui/icons-material/Description"; // For Exam QP
import AssignmentIcon from "@mui/icons-material/Assignment"; // For Internal Assessment
import NotesIcon from "@mui/icons-material/Notes"; // For Notes
import SummarizeIcon from "@mui/icons-material/Summarize"; // For Notes Summary
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import ExpandLess from "@mui/icons-material/ExpandLess";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import TopicIcon from "@mui/icons-material/Topic";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import ExpandMore from "@mui/icons-material/ExpandMore";
import VideocamIcon from "@mui/icons-material/Videocam";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { Breadcrumbs, Button, Collapse, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import NavBar from "./NavBar";
import CanAccess from "./access/CanAccess";
import ExamQP from "./BookContent/ExamQP";
import InternalAssessment from "./BookContent/InternalAssessment";
import Notes from "./BookContent/Notes";
import Syllabus from "./BookContent/Syllabus";
import NotesSummary from "./BookContent/NotesSummary";
import Videos from "./BookContent/Videos";
import TipsandTricks from "./BookContent/TipsandTricks";
import { ToastContainer } from "react-toastify";
import EssayQA from "./BookContent/EssayQA";
import ShortQA from "./BookContent/ShortQA";
import TopicWise from "./BookContent/TopicWise";
import VeryShort from "./BookContent/VeryShort";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SIALogo from "../assets/SIALogo.png";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";

const drawerWidth = 240;
// side navbar  menu Items
const menuItems = [
  { label: "Exam QP", icon: <DescriptionIcon /> },
  { label: "Internal Assessment", icon: <AssignmentIcon /> },
  { label: "Notes", icon: <NotesIcon /> },
  { label: "Notes Summary", icon: <SummarizeIcon /> },
  { label: "Syllabus", icon: <MenuBookIcon /> },
  { label: "Tips and Tricks", icon: <TipsAndUpdatesIcon /> },
  { label: "Videos", icon: <VideocamIcon /> },
];
function BooksContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const bookId = location.state?.data;
  const [bookContent, setBookContent] = useState([]);
  const [book, setBook] = useState([]);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("Exam QP");
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openLMR, setOpenLMR] = useState(false);
  const [openLMRPDF, setOpenLMRPDF] = useState(false);
  console.log(bookContent);
  console.log(book);

  // Submenu Open and close
  const handleSubMenuClick = () => {
    setOpenSubMenu((prev) => !prev);
  };
  //  Book Deatils get Api Fetching
  useEffect(() => {
    api
      .get(`/api/v1/bookContent/${bookId}`)
      .then(
        (res) => (
          setBookContent(res.data.data.bookUnitList),
          setBook(res.data.data.book)
        )
      )

      .catch((err) => console.error(err));
  }, []);
  return (
    <>
      <NavBar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <ToastContainer />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Drawer
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          variant="permanent"
          sx={{
            display: { xs: "none", md: "flex" },
            width: open ? 70 : 240,
            flexShrink: 0,
            transition: "width 0.3s ease",
            [`& .MuiDrawer-paper`]: {
              width: open ? 70 : 240,
              transition: "width 0.3s ease",
              boxSizing: "border-box",
              mt: "85px",
              height: "calc(100vh - 85px)",
              position: "fixed",
              overflowX: "hidden",
            },
          }}
        >
          <Box sx={{ overflow: "auto" }}>
            <List>
              {/* Regular Menu Items */}
              {/* Gate each content tab by permission key */}
              <CanAccess component="BOOKS_CONTENT_EXAM_QP">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Exam QP");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Exam QP" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <DescriptionIcon />
                    </ListItemIcon>
                    <ListItemText primary="Exam QP" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_INTERNAL_ASSESSMENT">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Internal Assessment");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Internal Assessment" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <AssignmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Internal Assessment" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_NOTES">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Notes");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Notes" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <NotesIcon />
                    </ListItemIcon>
                    <ListItemText primary="Notes" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_NOTES_SUMMARY">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Notes Summary");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Notes Summary" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <SummarizeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Notes Summary" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_SYLLABUS">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Syllabus");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Syllabus" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <MenuBookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Syllabus" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_TIPS_TRICKS">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Tips and Tricks");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Tips and Tricks" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <TipsAndUpdatesIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tips and Tricks" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_VIDEOS">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Videos");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Videos" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <VideocamIcon />
                    </ListItemIcon>
                    <ListItemText primary="Videos" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>

              {/* Submenu Toggle */}
              <CanAccess component="BOOKS_CONTENT_QA_MENU">
                <ListItemButton onClick={handleSubMenuClick}>
                  <ListItemIcon>
                    <TaskIcon />
                  </ListItemIcon>
                  <ListItemText primary="Question And Answers" />
                  {openSubMenu ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </CanAccess>

              <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* LMR */}
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setOpenLMR((prev) => !prev)}
                  >
                    <ListItemText primary="LMR" />
                    {openLMR ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>

                  <Collapse in={openLMR} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {["Essay Q&A", "Short Q&A", "Very Short Q&A"].map(
                        (item) => (
                          <ListItemButton
                            key={item}
                            sx={{
                              pl: 6,
                              ...(selectedMenu === item && {
                                backgroundColor: "#e3f2fd",
                              }),
                            }}
                            onClick={() => {
                              setSelectedMenu(item);
                              setMobileOpen(false);
                            }}
                          >
                            <ListItemText primary={item} />
                          </ListItemButton>
                        )
                      )}
                    </List>
                  </Collapse>

                  {/* LMR PDFs */}
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => setOpenLMRPDF((prev) => !prev)}
                  >
                    <ListItemText primary="LMR [PDFs]" />
                    {openLMRPDF ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>

                  <Collapse in={openLMRPDF} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{
                          pl: 6,
                          ...(selectedMenu === "Topic wise Q&A" && {
                            backgroundColor: "#e3f2fd",
                          }),
                        }}
                        onClick={() => {
                          setSelectedMenu("Topic wise Q&A");
                          setMobileOpen(false);
                        }}
                      >
                        <ListItemText primary="Topic wise Q&A" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </List>
              </Collapse>
            </List>
          </Box>
          {/* === Drawer Bottom Section === */}
          <Box
            sx={{
              p: 2,
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              bottom: "0",
              top: "0px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={() => navigate("/booklist")}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              color="primary"
              variant="text"
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Back
            </Button>
          </Box>
        </Drawer>
        {/* ===== Mobile Sidebar Drawer ===== */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          sx={{
            display: { xs: "flex", md: "none" },
            [`& .MuiDrawer-paper`]: {
              width: 240,
              boxSizing: "border-box",
              pt: "10px",
            },
          }}
        >
          {/* Sidebar Header / Toggle Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: mobileOpen ? "space-between" : "flex-end",
              alignItems: "center",
            }}
          >
            <IconButton edge="start" color="inherit" aria-label="logo">
              <Box
                component="img"
                src={SIALogo}
                alt="sia logo"
                sx={{ paddingLeft: "8px", width: "40px" }}
              />
            </IconButton>
            <IconButton
              onClick={() => setMobileOpen(!mobileOpen)}
              sx={{
                color: mobileOpen ? "primary.main" : "text.primary",
                transition: "color 0.3s ease, transform 0.3s ease",
                "&:hover": {
                  color: "primary.main",
                  transform: "scale(1.1)",
                },
              }}
            >
              {mobileOpen ? (
                <MenuOpenIcon fontSize="medium" />
              ) : (
                <MenuIcon fontSize="medium" />
              )}
            </IconButton>
          </Box>
          <Box sx={{ overflow: "auto" }}>
            <List>
              {/* Regular Menu Items */}
              {/* Gate each content tab by permission key */}
              <CanAccess component="BOOKS_CONTENT_EXAM_QP">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Exam QP");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Exam QP" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <DescriptionIcon />
                    </ListItemIcon>
                    <ListItemText primary="Exam QP" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_INTERNAL_ASSESSMENT">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Internal Assessment");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Internal Assessment" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <AssignmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Internal Assessment" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_NOTES">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Notes");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Notes" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <NotesIcon />
                    </ListItemIcon>
                    <ListItemText primary="Notes" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_NOTES_SUMMARY">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Notes Summary");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Notes Summary" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <SummarizeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Notes Summary" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_SYLLABUS">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Syllabus");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Syllabus" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <MenuBookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Syllabus" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_TIPS_TRICKS">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Tips and Tricks");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Tips and Tricks" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <TipsAndUpdatesIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tips and Tricks" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>
              <CanAccess component="BOOKS_CONTENT_VIDEOS">
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      setSelectedMenu("Videos");
                      setMobileOpen(false);
                    }}
                    sx={{
                      ...(selectedMenu === "Videos" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                  >
                    <ListItemIcon>
                      <VideocamIcon />
                    </ListItemIcon>
                    <ListItemText primary="Videos" />
                  </ListItemButton>
                </ListItem>
              </CanAccess>

              {/* Submenu Toggle */}
              <CanAccess component="BOOKS_CONTENT_QA_MENU">
                <ListItemButton onClick={handleSubMenuClick}>
                  <ListItemIcon>
                    <TaskIcon />
                  </ListItemIcon>
                  <ListItemText primary="Question And Answers" />
                  {openSubMenu ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </CanAccess>

              {/* Submenu Items */}
              <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{
                      pl: 4,
                      ...(selectedMenu === "Essay Q&A" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                    onClick={() => {
                      setSelectedMenu("Essay Q&A");
                      setMobileOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <AddToPhotosIcon />
                    </ListItemIcon>
                    <ListItemText primary="Essay Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{
                      pl: 4,
                      ...(selectedMenu === "Short Q&A" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                    onClick={() => {
                      setSelectedMenu("Short Q&A");
                      setMobileOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <HourglassTopIcon />
                    </ListItemIcon>
                    <ListItemText primary="Short Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{
                      pl: 4,
                      ...(selectedMenu === "Topic wise Q&A" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                    onClick={() => {
                      setSelectedMenu("Topic wise Q&A");
                      setMobileOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <TopicIcon />
                    </ListItemIcon>
                    <ListItemText primary="Topic wise Q&A" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{
                      pl: 4,
                      ...(selectedMenu === "Very Short Q&A" && {
                        backgroundColor: "#e3f2fd",
                      }),
                    }}
                    onClick={() => {
                      setSelectedMenu("Very Short Q&A");
                      setMobileOpen(false);
                    }}
                  >
                    <ListItemIcon>
                      <QuestionAnswerIcon />
                    </ListItemIcon>
                    <ListItemText primary="Very Short Q&A" />
                  </ListItemButton>
                </List>
              </Collapse>
            </List>
          </Box>
          {/* === Drawer Bottom Section === */}
          <Box
            sx={{
              p: 2,
              borderTop: "1px solid #e0e0e0",
              display: "flex",
              bottom: "0",
              top: "0px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={() => navigate("/booklist")}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              color="primary"
              variant="text"
              sx={{ textTransform: "none", fontWeight: 500 }}
            >
              Back
            </Button>
          </Box>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: { xs: 1, md: 3 }, mt: 10 }}>
          <Box>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
              <Link underline="hover" color="inherit" to="/booklist">
                Books List
              </Link>
              <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
                Book Units
              </Typography>
              <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
                {selectedMenu}
              </Typography>
            </Breadcrumbs>
          </Box>
          <Box sx={{ flex: 1, display: "flex" }}>
            <Typography sx={{ color: "#17479e" }}>Book Title : </Typography>
            <Typography sx={{ fontWeight: "600", marginLeft: "10px" }}>
              {book.title}
            </Typography>
          </Box>

          {selectedMenu === "Exam QP" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <ExamQP
                ExamQPBookunits="Bookunits"
                ExamQp={bookContent?.["Exam QP"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Internal Assessment" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <InternalAssessment
                InternalAssessment={bookContent?.["Internal Assessment"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Notes" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <Notes
                Notes={bookContent?.["Notes"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Notes Summary" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <NotesSummary
                NotesSummary={bookContent?.["Notes Summary"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Syllabus" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <Syllabus
                Syllabus={bookContent?.["Syllabus"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Tips and Tricks" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <TipsandTricks
                TipsandTricks={bookContent?.["Tips and Tricks"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Videos" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <Videos
                Videos={bookContent?.["Videos"] || []}
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Essay Q&A" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <EssayQA
                EssayQA={
                  bookContent?.["Question And Answers"]?.[
                    "Essay Questions and Answers"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Short Q&A" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <ShortQA
                ShortQA={
                  bookContent?.["Question And Answers"]?.[
                    "Short Questions and Answers"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )}
          {selectedMenu === "Topic wise Q&A" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <TopicWise
                TopicWiseQA={
                  bookContent?.["Question And Answers"]?.[
                    "Topic wise Question And Answer"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )}

          {selectedMenu === "Very Short Q&A" && (
            <Typography
              sx={{ marginTop: "30px", maxWidth: { xs: "395px", md: "100%" } }}
            >
              <VeryShort
                VeryShortQA={
                  bookContent?.["Question And Answers"]?.[
                    "Very Short Questions and Answers"
                  ] || []
                }
                setBookContent={setBookContent}
              />
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
}

export default BooksContent;
